import { Outlet, Navigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { ApplicationRole } from '../../models/authentication/application-roles';
import OwnerLayout from '../../pages/layouts/owner-layout';

interface OwnerRouteProps {
    allowSupplierManager?: boolean
}

export const OwnerRoute = ({ allowSupplierManager = false }: OwnerRouteProps) => {
    const { initialized, loading, authenticated, role } = useAuth();
    if (!initialized || loading) {
        return <div>Loading...</div>;
    }

    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    if (role === ApplicationRole.OrderApprover) {
        return <Navigate to="/admin/approvals" replace />;
    }


    const isOwner = role === ApplicationRole.Owner;
    const isSupplierManager = role === ApplicationRole.SupplierManager;

    if (!isOwner && !(allowSupplierManager && isSupplierManager)) {
        return <Navigate to="/home" replace />;
    }

    return (
        <OwnerLayout>
            <Outlet />
        </OwnerLayout>
    )
};